module.exports = __webpack_public_path__ + "assets/img/finish-backListBtn-zh.854eb35a.png";